function collapseInit() {

    !function ($) {
        $(document).ready(function () {
            function accordionOpen(_id){
                $(_id).find('.accordion-toggle').on('click', function(event){
                    _group = $(this).parent().parent().parent().find('.accordion-group').removeClass("open")
                    var _group = $(this).parent().parent();
                    _group.addClass("open")
                });
            }
            //accordionOpen(id 名稱,指定開啟選單號碼)
            accordionOpen("#collapse-ct");
        })
    }(window.jQuery);
}

export {collapseInit}


// WEBPACK FOOTER //
// ./src/util/collapseScript.js